module.exports = "/assets/data/34a4e0d583f640a8dda39ef5dab13b5c-DE65.data.json";